__turbopack_context__.v({
  "arrow": "AnnouncementBar-module-scss-module__NRNs6a__arrow",
  "bar": "AnnouncementBar-module-scss-module__NRNs6a__bar",
  "icon": "AnnouncementBar-module-scss-module__NRNs6a__icon",
  "inner": "AnnouncementBar-module-scss-module__NRNs6a__inner",
  "logoImg": "AnnouncementBar-module-scss-module__NRNs6a__logoImg",
  "slide": "AnnouncementBar-module-scss-module__NRNs6a__slide",
  "text": "AnnouncementBar-module-scss-module__NRNs6a__text",
  "track": "AnnouncementBar-module-scss-module__NRNs6a__track",
  "viewport": "AnnouncementBar-module-scss-module__NRNs6a__viewport",
});
